module.exports = {"id":"dp5_1l3q2","text":"Troubleshooting strategies","instructions":"Which action supports diagnosing a recurring software issue?","multiselect":false,"category":"5.1","questionType":"PickOne","random":true,"options":[{"id":"dp5_1l3q2-a1","text":"Searching error messages online","score":3.7},{"id":"dp5_1l3q2-a2","text":"Ignoring the problem temporarily","score":1.3},{"id":"dp5_1l3q2-a3","text":"Restarting without review","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l3q2.json
// module id = 1287
// module chunks = 41